import type { NotifyApiDatasource } from '../datasources/notify-api.datasource';
import type {
  EmailMessage,
  ListEmailMessagesInput,
  Paginated,
  RetryFailedEmailInput,
} from '../../domain/entities/notify.entity';

export class NotifyRepositoryImpl {
  private api: NotifyApiDatasource;

  constructor(api: NotifyApiDatasource) {
    this.api = api;
  }

  listEmails(input?: ListEmailMessagesInput): Promise<Paginated<EmailMessage>> {
    return this.api.listEmails(input);
  }

  retryEmail(id: string, body: RetryFailedEmailInput): Promise<EmailMessage> {
    return this.api.retryEmail(id, body);
  }
}
